// removed by extract-text-webpack-plugin
module.exports = {"base":"ButtonTiny_base--2HcHp","base__default":"ButtonTiny_base__default--3JqZI","baseDefault":"ButtonTiny_base__default--3JqZI","base__secondary":"ButtonTiny_base__secondary--20NyJ","baseSecondary":"ButtonTiny_base__secondary--20NyJ","disabled":"ButtonTiny_disabled--2eZtJ","icon":"ButtonTiny_icon--1IPDo"};


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/ButtonTiny.scss
// module id = 415
// module chunks = 11 12